import TextField from '@Fields/TextField';
import SelectField from '@Fields/SelectField';
import AutoCompleteField from '@Fields/AutoCompleteField';
import RadioField from '@Fields/RadioField';
import CheckBoxListField from '@Fields/CheckBoxListField';
import ModalSwitchSpecUnitsForm from '@Forms/ModalSwitchSpecUnitsForm';

class SpecsForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.showUnitSwitchModal = this.showUnitSwitchModal.bind(this);
        this.autocompleteListUpdate = this.autocompleteListUpdate.bind(this);
        this.dynamicAutoAndDrop = this.dynamicAutoAndDrop.bind(this);
        this.AdditionaDetailsClick = this.AdditionaDetailsClick.bind(this);

        this.state = props.model;

        let state = this.state;
        state.showUnitSwitchModal = this.showUnitSwitchModal;
        this.props.handleMasterViewUpdate(state);
    }

    componentWillReceiveProps(Props) {
        if (Props.model.oMMMCategoryGroupSpecs != null) {
            this.setState({
                oMMMCategoryGroupSpecs: Props.model.oMMMCategoryGroupSpecs,
                oMMMCategoryGroupSpecPage: Props.model.oMMMCategoryGroupSpecPage,
                oMMMDefaultSpecList: Props.model.oMMMDefaultSpecList,
                oMMMMeasurementUnit: Props.model.oMMMMeasurementUnit,
                oMMMCategorySpec: Props.model.oMMMCategorySpec,
                oDynamicAutoComplete: Props.model.oDynamicAutoComplete,
                oDynamicDropDown: Props.model.oDynamicDropDown,
                DependentAutoComplete: Props.model.DependentAutoComplete,
                DependentDropDowns: Props.model.DependentDropDowns,
                DependentBundledSpecs: Props.model.DependentBundledSpecs,
                FormInputs: Props.model.FormInputs,
                FormErrors: Props.model.FormErrors,
                ShowModal: Props.model.ShowModal,
                oSpecsModal: Props.model.oSpecsModal,
                SerialVIN: Props.model.SerialVIN,
                ShowFE: Props.model.ShowFE,
                Category: Props.model.Category,
                Manufacturer: Props.model.Manufacturer,
                Model: Props.model.Model,
                Year: Props.model.Year,
                SystemOfMeasurement: Props.model.SystemOfMeasurement,
                ObjectXMLInputs: Props.model.ObjectXMLInputs,
                ValidFECategory: Props.model.ValidFECategory,
                SpecGroupLastSeen: Props.model.SpecGroupLastSeen,
                MoreSpecsClicks: Props.model.MoreSpecsClicks,
                DoneWithSpecsClicks: Props.model.DoneWithSpecsClicks,
                GroupIndex: Props.model.GroupIndex,
                SpecIndex: Props.model.SpecIndex,
                CurrentPage: Props.model.CurrentPage,
                QueryString: Props.model.QueryString,
                NextPageURL: Props.model.NextPageURL,
                Translations: Props.model.Translations,
                Progress: Props.model.Progress,
                PageNames: Props.model.PageNames,
                ClassNamesForProgressBar: Props.model.ClassNamesForProgressBar,
                IndexGeneralNotShownInSpecSection: Props.model.IndexGeneralNotShownInSpecSection,
                HighlightErrors: Props.model.HighlightErrors,
                InputErrors: Props.model.InputErrors,
                ShowUnitSwitchModal: Props.model.ShowUnitSwitchModal,
                firstSpecWithUnit: Props.model.firstSpecWithUnit,
                modalObject: Props.model.modalObject,
                CurrentSite: Props.model.CurrentSite,
                SimplifiedSite: Props.model.SimplifiedSite
            });
        }
    }

    handleFieldChanged(field, value) {
        let state = this.state

        //HeadCountDateSelected
        if (field.indexOf('DateSelected') >= 0) {
            field = field.split("DateSelected")[0];
        }

        if (state.FormInputs[field].Value == "foot") {
            let inchfield = field.substring(0, field.length - 5) + "inch#";
            state.FormInputs[inchfield].Value = "";
            delete state.HighlightErrors[inchfield];
            delete state.InputErrors[inchfield];
        }
        state.FormInputs[field] = { Value: value, Page: state.FormInputs[field].Page };

        //if this is a unit spec see if we want to switch them all to that unit
        let bIsUnitSpec = field.indexOf("unit#") >= 0;
        let specField = field;
        if (bIsUnitSpec) {
            specField = field.split('unit#')[0];
        }
        else if (field.indexOf("inch#") >= 0) {
            specField = field.split('inch#')[0];
        }

        //get the spec
        let spec = null
        let oMMMCategoryGroupSpecPage = state.oMMMCategoryGroupSpecs.filter(function (CategoryGroupSpecPage) {
            let page = CategoryGroupSpecPage.Specs.filter(function (categorygroupspec) {
                return categorygroupspec.SpecField == specField;
            });

            if (page.length > 0) {
                spec = page[0];
                return page;
            }
        });

        if (bIsUnitSpec) {
            state = this.showUnitSwitchModal(state, spec, field, value);
        }
        else {
            //update spec
            this.autocompleteListUpdate(field, value, state, spec);
            this.dynamicAutoAndDrop(field, value, state, oMMMCategoryGroupSpecPage);

            //update show modal logic if this is a spec with units.
            if (state.ShowUnitSwitchModal && state.firstSpecWithUnit == null) {

                //has units
                let unitSpec = state.FormInputs[field + "unit#"];
                if (unitSpec != null) {
                    let bHasYourSystemOfMeasure = false;

                    //get all the unit options for this spec and the get the selected option.
                    for (let a in spec.MeasurementUnitOptions) {
                        for (let b in this.state.oMMMMeasurementUnit) {
                            if (spec.MeasurementUnitOptions[a] == this.state.oMMMMeasurementUnit[b].MeasurementUnitID) {
                                if (this.state.oMMMMeasurementUnit[b].UnitSystem == "Imperial") //this will need to be system of measure
                                    bHasYourSystemOfMeasure = true;
                                break;
                            }
                        }
                    }

                    if (bHasYourSystemOfMeasure) {
                        state.firstSpecWithUnit = spec;
                    }
                }
            }
        }

        this.props.handleMasterViewUpdate(state);
    }

    handleOnBlur(field, e) {
        let parentState = this.props.model;
        let state = this.state;

        if (parentState.FormInputs[field].Value != null && parentState.FormInputs[field].Value != state.FieldValue) {
            //get the spec
            let spec = null;
            parentState.oMMMCategoryGroupSpecs.filter(function (CategoryGroupSpecPage) {
                let page = CategoryGroupSpecPage.Specs.filter(function (categorygroupspec) {
                    return categorygroupspec.SpecField == field;
                });

                if (page.length > 0) {
                    spec = page[0];
                    return page;
                }
            });

            this.props.ValidateSpec(spec, parentState, (validationObject) => {
                //if an error, only update that fields state, if no error then clear the error
                if ((validationObject.highlightErrors[spec.SpecField] && parentState.FormInputs[field].Value != "" && validationObject.correctSpecValue == null || validationObject.correctSpecValue == "") ||
                    (validationObject.highlightErrors[spec.SpecField + "inch#"] && parentState.FormInputs[field + "inch#"].Value != "")) {

                    parentState.HighlightErrors[spec.SpecField] = validationObject.highlightErrors[spec.SpecField];
                    parentState.InputErrors[spec.SpecField] = validationObject.inputErrors[spec.SpecField];
                    parentState.HighlightErrors[spec.SpecField + "unit#"] = validationObject.highlightErrors[spec.SpecField + "unit#"];
                    parentState.InputErrors[spec.SpecField + "unit#"] = validationObject.inputErrors[spec.SpecField + "unit#"];
                    parentState.HighlightErrors[spec.SpecField + "inch#"] = validationObject.highlightErrors[spec.SpecField + "inch#"];
                    parentState.InputErrors[spec.SpecField + "inch#"] = validationObject.inputErrors[spec.SpecField + "inch#"];

                    this.setState({
                        HighlightErrors: parentState.HighlightErrors,
                        InputErrors: parentState.InputErrors
                    });
                }
                else {
                    if (validationObject.correctSpecValue != null && validationObject.correctSpecValue != "") {
                        state.FormInputs[field].Value = validationObject.correctSpecValue;
                    }

                    delete parentState.HighlightErrors[spec.SpecField];
                    delete parentState.InputErrors[spec.SpecField];
                    delete parentState.HighlightErrors[spec.SpecField + "unit#"];
                    delete parentState.InputErrors[spec.SpecField + "unit#"];
                    delete parentState.HighlightErrors[spec.SpecField + "inch#"];
                    delete parentState.InputErrors[spec.SpecField + "inch#"];

                    let bNoErrors = Object.keys(state.InputErrors).length == 0;
                    if (bNoErrors) {
                        state.FormErrors = [];
                    }

                    this.setState({
                        HighlightErrors: parentState.HighlightErrors,
                        InputErrors: parentState.InputErrors,
                        FormErrors: state.FormErrors,
                    });
                }
            });
            this.props.handleMasterViewUpdate(state);
        }
    }

    handleOnFocus(field, e) {
        let value = e.target.value;

        this.setState({
            FieldValue: value
        });
    }

    handleCloseSection(element) {
        //additional-details
        let className = element.target.className.replace("spec-group-label", "").trim();
        let test = $("." + className).parent();
        let bIsAddtlDetailsHeader = element.target.className == "additional-details" || test[0].className == "additional-details";

        let state = this.state;

        let bHasErrors = this.props.ValidateAndSaveSpecs(true, this.state, true);
        if (bHasErrors) {

            //get the list of required specs
            let bSkipSpecs = [];
            $(".required-spec").each(function () {
                let element = $(this);
                bSkipSpecs.push(element[0].id);
            });
            $(".accordian-skip").each(function () {
                let element = $(this);
                bSkipSpecs.push(element[0].id);
            });

            //we'll check if all the errors are just required specs. IF they are, we'll allow the addtl specs to open
            //otherwise we'll prevent addtl specs section to toggle
            let bOnlyRequiredErrors;
            if (bSkipSpecs.length > 0) {
                bOnlyRequiredErrors = true;

                for (let key in this.state.InputErrors) {
                    if (this.state.InputErrors[key] != null && bSkipSpecs.indexOf(key) < 0)
                        bOnlyRequiredErrors = false;
                }
            }

            bHasErrors = !bOnlyRequiredErrors;
        }

        if (!bHasErrors) {
            //toggle sections
            if (bIsAddtlDetailsHeader) {
                AdditionalDetailsToggle();
            }
            else {
                //get the id to toggle
                let index1 = element.target.id.lastIndexOf("-") + 1;
                let index2 = element.target.id.length;
                let difference = index2 - index1;
                let id = element.target.id.substr(index1, difference);
                ToggleSpecsSection(id);
            }

            state.FormErrors = [];
            this.props.handleFormUpdate(state);
        }
        else {
            //show error at the top?
            if (state.FormErrors.length == 0)
                state.FormErrors.push(state.Translations["CorrectBeforeProceeding"]);

            this.props.handleFormUpdate(state);
            this.props.handleMasterViewUpdate(state);
        }
    }

    //Methods
    showUnitSwitchModal(state, spec, field, value) {
        //do we even need to load the modal
        if (this.state.ShowUnitSwitchModal && (state.firstSpecWithUnit == spec || state.firstSpecWithUnit == null)) {
            let selectedValue = ToTitleCase(this.state.FormInputs[field].Value),
                selectedOption = {},
                bHasYourSystemOfMeasure = false,
                SystemOfMeasurement = ToTitleCase(state.SystemOfMeasurement);

            //get all the unit options for this spec and the get the selected option.
            for (let a in spec.MeasurementUnitOptions) {
                for (let b in this.state.oMMMMeasurementUnit) {
                    if (spec.MeasurementUnitOptions[a] == this.state.oMMMMeasurementUnit[b].MeasurementUnitID) {
                        if (this.state.oMMMMeasurementUnit[b].UnitSystem == SystemOfMeasurement) //this will need to be system of measure
                            bHasYourSystemOfMeasure = true;
                        if (this.state.oMMMMeasurementUnit[b].Unit == selectedValue.toLowerCase())
                            selectedOption = this.state.oMMMMeasurementUnit[b];
                        break;
                    }
                }
            }

            //selected option needs to match users System of Measure (determined by tld)
            if (selectedOption.UnitSystem != SystemOfMeasurement) { // this will need to be system of measure
                //if bHasImperialUnits, if showModal = true, make it false.
                if (bHasYourSystemOfMeasure) {
                    //build a modal object so that it can get passed down to show modal
                    state.ShowUnitSwitchModal = false;
                    let modalObject = {
                        NewUnit: selectedOption.UnitSystem,
                        PreviousUnit: SystemOfMeasurement,
                        ShowModal: true,
                        SpecField: field,
                        SpecValue: value,
                    };
                    state.modalObject = modalObject;
                }
            }
        }
        else {
            //if a spec was updated but didn't have it's unit changed, don't show the modal
            state.ShowUnitSwitchModal = false;
        }

        return state;
    }

    autocompleteListUpdate(field, value, state, spec) {
        if (state.DependentAutoComplete != null && spec != null) {

            let oDynamicAutoComplete = state.oDynamicAutoComplete;
            for (let b = 0; b < oDynamicAutoComplete.length; b++) {
                if (oDynamicAutoComplete[b].DefinedSpecID == spec.DefinedSpecID) {
                    if (value.length >= 2) {
                        let autoI = b

                        oDynamicAutoComplete[b].TypedText = value;

                        let xhr1 = new XMLHttpRequest();
                        xhr1.onload = function () {
                            let response = JSON.parse(xhr1.response);

                            state.FormInputs[field].Value = this.state.FormInputs[field].Value;
                            if (response.oDynamicAutoComplete.TypedText == state.FormInputs[field].Value) {
                                oDynamicAutoComplete[autoI].Source = response.oDynamicAutoComplete.Source

                                let autocompletes = state.DependentAutoComplete;
                                for (let autocomplete of autocompletes) {
                                    if (response.oDynamicAutoComplete.DefinedSpecID == autocomplete.SpecID)
                                        autocomplete.Source = response.oDynamicAutoComplete.Source;
                                }

                                state.oDynamicAutoComplete = oDynamicAutoComplete;
                                state.DependentAutoComplete = autocompletes;
                            }

                            this.props.handleFormUpdate(state);
                        }.bind(this);

                        xhr1.open("POST", '/listinginput/base/DynamicAutoComplete', true);
                        xhr1.setRequestHeader("Content-type", "application/json");
                        xhr1.send(JSON.stringify(oDynamicAutoComplete[b]));
                    }
                    else {
                        oDynamicAutoComplete[b].TypedText = value;

                        oDynamicAutoComplete[b].Source = []

                        let autocompletes = this.state.DependentAutoComplete;
                        for (let autocomplete of autocompletes) {
                            if (oDynamicAutoComplete[b].DefinedSpecID == autocomplete.SpecID)
                                autocomplete.Source = [];
                        }

                        state.oDynamicAutoComplete = oDynamicAutoComplete;
                        state.DependentAutoComplete = autocompletes;
                    }
                }
            }
        }
    }

    dynamicAutoAndDrop(field, value, state, oMMMCategoryGroupSpecPage) {
        if (oMMMCategoryGroupSpecPage.length > 0) {
            if (state.DependentAutoComplete != null) {
                let depautocompletes = state.DependentAutoComplete.filter(function (depAutoComplete) { return depAutoComplete.DependentSpecName == field; });
                if (depautocompletes.length > 0) {
                    for (let depautocomplete of depautocompletes) {

                        let dependee = state.oDynamicAutoComplete.filter(function (dynamicauto) { return dynamicauto.DefinedSpecID == depautocomplete.DependentSpecID; });
                        if (dependee.length == 0)
                            dependee = state.oDynamicDropDown.filter(function (dynamicdrop) { return dynamicdrop.DefinedSpecID == depautocomplete.DependentSpecID; });

                        let dependeespec = oMMMCategoryGroupSpecPage[0].Specs.find(function (categorygroupspec) { return categorygroupspec.DefinedSpecID == depautocomplete.DependentSpecID; });

                        //check if value(input) matches an autocomplete, select that exact input
                        let inList = true;
                        if (dependeespec.SpecInputControlType == "AutoComplete") {
                            let inSource = dependee[0].Source.filter(function (source) { return source.toLowerCase() == value.toLowerCase(); });
                            //the value isn't in the list
                            if (inSource.length == 0) {
                                inList = false;
                            }
                            else {
                                value = inSource[0];
                                state.FormInputs[field] = { Value: value, Page: state.FormInputs[field].Page };
                            }
                        }
                        //if the value we wanted is in the list
                        if (inList) {
                            let oDynamicAutoCompletes = state.oDynamicAutoComplete;
                            for (let oDynamicAutoComplete of oDynamicAutoCompletes) {
                                //make sure these have the same spec ids
                                if (oDynamicAutoComplete.DefinedSpecID == depautocomplete.SpecID) {
                                    oDynamicAutoComplete.Dependencies = [{ key: depautocomplete.DependentSpecID, value: value }];

                                    let autocompletes = state.DependentAutoComplete;

                                    //if the autocompletes spec ID matches up w/ the one pulled back from API, then enable it
                                    for (let autocomplete of autocompletes) {
                                        if (oDynamicAutoComplete.DefinedSpecID == autocomplete.SpecID) {
                                            autocomplete.Disabled = false;
                                        }
                                    }

                                    state.oDynamicAutoComplete = oDynamicAutoCompletes;
                                    state.DependentAutoComplete = autocompletes;
                                }
                            }
                            //the value we wanted is NOT in the list
                        }
                        else {
                            let oDynamicAutoCompletes = state.oDynamicAutoComplete;
                            for (let oDynamicAutoComplete of oDynamicAutoCompletes) {
                                if (oDynamicAutoComplete.DefinedSpecID == depautocomplete.SpecID) {
                                    let autocompletes = state.DependentAutoComplete;
                                    for (let autocomplete of autocompletes) {
                                        //disable the autocomplete since it doesn't contain the value we want
                                        if (oDynamicAutoComplete.DefinedSpecID == autocomplete.SpecID) {
                                            autocomplete.Disabled = true;

                                            state.FormInputs[autocomplete.SpecField].Value = "";
                                        }
                                    }

                                    state.DependentAutoComplete = autocompletes;
                                }
                            }
                        }
                    }
                }
            }
            if (state.DependentDropDowns != null) {
                let depdropdowns = state.DependentDropDowns.filter(function (depDropDown) { return depDropDown.DependentSpecName == field; });
                if (depdropdowns.length > 0) {
                    for (let i = 0; i < depdropdowns.length; i++) {

                        let dependee = state.oDynamicAutoComplete.filter(function (dynamicauto) { return dynamicauto.DefinedSpecID == depdropdowns[i].DependentSpecID; });
                        if (dependee.length == 0)
                            dependee = state.oDynamicDropDown.filter(function (dynamicdrop) { return dynamicdrop.DefinedSpecID == depdropdowns[i].DependentSpecID; });

                        let dependeespec = oMMMCategoryGroupSpecPage.Specs.find(function (categorygroupspec) { return categorygroupspec.DefinedSpecID == depdropdowns[i].DependentSpecID; });

                        let inList = true;
                        if (dependeespec.SpecInputControlType == "AutoComplete") {
                            let inSource = dependee[0].Source.filter(function (source) { return source.toLowerCase() == value.toLowerCase(); });
                            if (inSource.length == 0) {
                                inList = false;
                            }
                        }

                        if (inList) {
                            let oDynamicDropDown = state.oDynamicDropDown;
                            for (let b = 0; b < oDynamicDropDown.length; b++) {
                                if (oDynamicDropDown[b].DefinedSpecID == depdropdowns[i].SpecID) {
                                    let dropI = b
                                    oDynamicDropDown[b].Dependencies = [{ key: depdropdowns[i].DependentSpecID, value: value }];
                                    oDynamicDropDown[b].DropDownOptions = null;

                                    let xhr2 = new XMLHttpRequest();
                                    xhr2.onload = function () {
                                        let response = JSON.parse(xhr2.response);
                                        let dropdowns = state.DependentDropDowns;
                                        let formInputs = state.FormInputs;

                                        state.FormInputs[field].Value = this.state.FormInputs[field].Value;
                                        if (response.oDynamicDropDown.TypedText == state.FormInputs[field].Value) {

                                            for (let dropdown of dropdowns) {
                                                if (response.oDynamicDropDown.DefinedSpecID == dropdown.SpecID) {
                                                    let index = 0;

                                                    for (let DropDownOption of response.oDynamicDropDown.DropDownOptions) {
                                                        if (DropDownOption.Enabled) {
                                                            index = i;
                                                            break;
                                                        }
                                                    }
                                                    state.FormInputs[dropdown.SpecField] = { Value: response.oDynamicDropDown.DropDownOptions[index].Value, Page: state.FormInputs[dropdown.SpecField].Page };

                                                    //if only one category fits, automatically select it. 
                                                    let newlist = response.oDynamicDropDown.DropDownOptions.filter(function (options) { return options.Value != "" && options.Enabled; });
                                                    if (newlist.length == 1)
                                                        state.FormInputs[dropdown.SpecField] = { Value: newlist[0].Value, Page: state.FormInputs[dropdown.SpecField].Page };

                                                    oDynamicDropDown[dropI].DropDownOptions = response.oDynamicDropDown.DropDownOptions
                                                    dropdown.DropDownOptions = response.oDynamicDropDown.DropDownOptions;
                                                    dropdown.Disabled = false;
                                                }
                                            }

                                            state.FormInputs = formInputs;
                                            state.oDynamicDropDown = oDynamicDropDown;
                                            state.DependentDropDowns = dropdowns;
                                        }
                                        this.props.handleFormUpdate(state);
                                    }.bind(this);

                                    xhr2.open("POST", '/listinginput/base/DynamicDropDowns', true);
                                    xhr2.setRequestHeader("Content-type", "application/json");
                                    xhr2.send(JSON.stringify(oDynamicDropDown[b]));
                                }
                            }
                        }
                        else {
                            let oDynamicDropDowns = state.oDynamicDropDown;
                            for (let oDynamicDropDown of oDynamicDropDowns) {
                                if (oDynamicDropDown.DefinedSpecID == depdropdowns[i].SpecID) {
                                    let dropdowns = state.DependentDropDowns;
                                    for (let dropdown of dropdowns) {
                                        if (oDynamicDropDown.DefinedSpecID == dropdown.SpecID) {
                                            dropdown.Disabled = true;
                                            dropdown.DropDownOptions = "";

                                            state.FormInputs[dropdowns[0].SpecField] = { Value: "", Page: state.FormInputs[dropdowns[0].SpecField].Page };
                                        }
                                    }
                                    state.DependentDropDowns = dropdowns;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    AdditionaDetailsClick() {
        let bNoErrors = Object.keys(this.state.InputErrors).length == 0;
        let bOnlyRequiredErrors = false;

        if (!bNoErrors) {

            //get the list of required specs
            let bSkipSpecs = [];
            $(".required-spec").each(function () {
                let element = $(this);
                bSkipSpecs.push(element[0].id);
            });
            $(".accordian-skip").each(function () {
                let element = $(this);
                bSkipSpecs.push(element[0].id);
            });
            
            //we'll check if all the errors are just required specs. IF they are, we'll allow the addtl specs to open
            //otherwise we'll prevent addtl specs section to toggle
            if (bSkipSpecs.length > 0) {
                bOnlyRequiredErrors = true;

                for (let key in this.state.InputErrors) {
                    if (this.state.InputErrors[key] != null && bSkipSpecs.indexOf(key) < 0)
                        bOnlyRequiredErrors = false;
                }
            }

            AdditionalDetailsToggle(bOnlyRequiredErrors);
        }
        else {
            AdditionalDetailsToggle(true);
        }
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    render() {
        let prioritySpecs = [];
        let addtlSpecsSection = [];
        let addtlGroups = [];
        let simpleSpecSection = [];
        let simpleSpecGroups = [];

        if (this.state.oMMMCategoryGroupSpecs != null) {
            let groupNameIndex = 0;
            for (let groupIndex = 0; groupIndex < this.state.oMMMCategoryGroupSpecs.length; groupIndex++) {
                let oMMMCategoryGroupSpecPage = this.state.oMMMCategoryGroupSpecs[groupIndex];
                if (oMMMCategoryGroupSpecPage != null && oMMMCategoryGroupSpecPage.GroupName != "Charter" && oMMMCategoryGroupSpecPage.GroupName != "General - Not Shown In Specs Section") {

                    //if priority section. We show that with the listing detail section CSS. Additonal Details have completely different CSS
                    if (this.state.Translations["PrioritySpecs"].includes(oMMMCategoryGroupSpecPage.GroupName)) {
                        //Header
                        if (this.state.IsInTranslationEditorMode) {
                            prioritySpecs.push(
                                <h3 key={oMMMCategoryGroupSpecPage.GroupName}>{oMMMCategoryGroupSpecPage != null ? this.getTranslation("PrioritySpecs") : ""}</h3>
                            );
                        }
                        else {
                            prioritySpecs.push(
                                <h3 key={oMMMCategoryGroupSpecPage.GroupName}>{oMMMCategoryGroupSpecPage != null ? oMMMCategoryGroupSpecPage.GroupName : ""}</h3>
                            );
                        }
                        //required Specs 
                        for (let spec of oMMMCategoryGroupSpecPage.Specs) {
                            if (spec.Example == null) {
                                spec.Example = "";
                            }
                            switch (spec.SpecInputControlType) {
                                case "MultiLineTextBox": {
                                    prioritySpecs.push(
                                        <div className="form-row" key={spec.SpecField}>
                                            <label className="label-left" htmlFor={spec.SpecField}>{spec.Label + " " + spec.Example}</label>
                                            <div className="input-right required-spec" id={"div" + spec.SpecField}>
                                                <TextField
                                                    type="textarea"
                                                    feRequired={spec.RecommendedForEvaluation}
                                                    id={spec.SpecField}
                                                    value={this.state.FormInputs[spec.SpecField].Value}
                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                    error={this.state.HighlightErrors[spec.SpecField]}
                                                    errorText={this.state.InputErrors[spec.SpecField]}
                                                    hasLabel={true}
                                                />
                                            </div>
                                        </div>
                                    );
                                    break;
                                }
                                case "CheckBox": {
                                    if (this.state.FormInputs[spec.SpecField].Value == "") {
                                        this.state.FormInputs[spec.SpecField].Value = "0";
                                    }
                                    prioritySpecs.push(
                                        <div className="form-row" key={spec.SpecField}>
                                            <label className="label-left" htmlFor={spec.SpecField}>{spec.Label + " " + spec.Example}</label>
                                            <div className="input-right required-spec" id={"div" + spec.SpecField}>
                                                <TextField
                                                    feRequired={spec.RecommendedForEvaluation}
                                                    id={spec.SpecField}
                                                    onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                    onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                    YesNo={spec.IsYesNo}
                                                    type="checkbox"
                                                    value={this.state.FormInputs[spec.SpecField].Value}
                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                    error={this.state.HighlightErrors[spec.SpecField]}
                                                    errorText={this.state.InputErrors[spec.SpecField]}
                                                    hasLabel={true}
                                                />
                                            </div>
                                        </div>
                                    );
                                    break;
                                }
                                case "CheckBoxList": {
                                    let checkboxesEven = [];
                                    let checkboxesOdd = [];
                                    for (let c = 0; c < spec.InputControlListOptions.length; c++) {
                                        if (c % 2 == 0)
                                            checkboxesEven.push({ text: spec.InputControlListOptions[c].Text, value: spec.InputControlListOptions[c].Value })
                                        else
                                            checkboxesOdd.push({ text: spec.InputControlListOptions[c].Text, value: spec.InputControlListOptions[c].Value })
                                    }
                                    prioritySpecs.push(
                                        <div className="form-row" key={spec.SpecField}>
                                            <span className="label-left">{spec.Label + " " + spec.Example}</span>
                                            <div className="input-right required-spec" style={{ maxHeight: '175px', overflowY: 'auto' }} id={spec.SpecField}>
                                                <div className="input-left" style={{ width: '50%' }}>
                                                    <CheckBoxListField
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        id={spec.SpecField}
                                                        checkboxes={checkboxesEven}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        isvertical={false}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                        hasLabel={true}
                                                    />
                                                </div>
                                                <div className="input-left" style={{ width: '50%' }}>
                                                    <CheckBoxListField
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        id={spec.SpecField}
                                                        checkboxes={checkboxesOdd}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        isvertical={false}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                        hasLabel={true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="validationError">
                                                <span>{this.state.InputErrors[spec.SpecField]}</span>
                                            </div>
                                        </div>
                                    );
                                    break;
                                }
                                case "TextBox": {
                                    if (spec.DatabaseUnit != null && spec.MeasurementUnitOptions != null) {

                                        let selectID = spec.SpecField + "unit#";

                                        let selectvalues = [];

                                        for (let UnitOption of spec.MeasurementUnitOptions) {
                                            for (let MeasurementUnit of this.state.oMMMMeasurementUnit) {
                                                if (UnitOption == MeasurementUnit.MeasurementUnitID) {
                                                    selectvalues.push({ text: MeasurementUnit.Symbol, value: MeasurementUnit.Unit })
                                                    break;
                                                }
                                            }
                                        }

                                        if (this.state.FormInputs[selectID].Value == "foot") {
                                            let inchfield = spec.SpecField + "inch#";
                                            prioritySpecs.push(
                                                <div className="form-row" key={spec.SpecField}>
                                                    <label className="label-left" htmlFor={spec.SpecField} id={spec.SpecField + "label"}>{spec.Label + " " + spec.Example} </label>
                                                    <div className="input-right required-spec">
                                                        <TextField
                                                            type="number"
                                                            min="0"
                                                            feRequired={spec.RecommendedForEvaluation}
                                                            onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                            onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                            AddCommas={spec.SpecDataFormat == "Number"}
                                                            id={spec.SpecField}
                                                            value={this.state.FormInputs[spec.SpecField].Value}
                                                            SmallInput={true}
                                                            className={"footSpecText"}
                                                            mileageinch={true}
                                                            onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                            error={this.state.HighlightErrors[spec.SpecField]}
                                                            errorText={this.state.InputErrors[spec.SpecField]}
                                                            hasLabel={true}
                                                        />
                                                        <SelectField
                                                            id={selectID}
                                                            value={this.state.FormInputs[selectID].Value}
                                                            SmallSelect={true}
                                                            className={"required-v-small-select"}
                                                            values={selectvalues}
                                                            mileageinch={true}
                                                            onFieldChanged={(e) => { this.handleFieldChanged(selectID, e); }}
                                                            bShowFullName={true}
                                                            error={this.state.HighlightErrors[selectID]}
                                                            errorText={this.state.InputErrors[selectID]}
                                                            hasLabel={true}
                                                            ariaLabelledBy={spec.SpecField + "label"}
                                                        />
                                                        <TextField
                                                            type="number"
                                                            min="0"
                                                            feRequired={spec.RecommendedForEvaluation}
                                                            onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                            onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                            AddCommas={spec.SpecDataFormat == "Number"}
                                                            id={inchfield}
                                                            SmallInput={true}
                                                            className={"inchSpecText"}
                                                            value={this.state.FormInputs[inchfield].Value}
                                                            mileageinchsecond={true}
                                                            onFieldChanged={(e) => { this.handleFieldChanged(inchfield, e); }}
                                                            error={this.state.HighlightErrors[inchfield]}
                                                            errorText={this.state.InputErrors[inchfield]}
                                                            hasLabel={true}
                                                        />
                                                        <label htmlFor={inchfield}> in.</label>
                                                        <div className="validationError">
                                                            <span>{this.state.InputErrors[spec.SpecField]}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                        else {
                                            prioritySpecs.push(
                                                <div className="form-row" key={spec.SpecField}>
                                                    <label className="label-left" htmlFor={spec.SpecField} id={spec.SpecField + "label"}>{spec.SpecField}</label>
                                                    <div className="input-right required-spec" id={"div" + spec.SpecField}>
                                                        <div className="input-left" style={{ width: 'calc(100% - 90px)' }}>
                                                            <TextField
                                                                type={spec.SpecDataFormat == "Number" ? "number" : null}
                                                                min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                                feRequired={spec.RecommendedForEvaluation}
                                                                id={spec.SpecField}
                                                                onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                                onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                                value={this.state.FormInputs[spec.SpecField].Value}
                                                                onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                                error={this.state.HighlightErrors[spec.SpecField]}
                                                                hasLabel={true}
                                                            />
                                                        </div>
                                                        <div className="labels-right">
                                                            <SelectField
                                                                id={selectID}
                                                                value={this.state.FormInputs[selectID].Value}
                                                                values={selectvalues}
                                                                mileage={true}
                                                                onFieldChanged={(e) => { this.handleFieldChanged(selectID, e); }}
                                                                error={this.state.HighlightErrors[selectID]}
                                                                errorText={this.state.InputErrors[selectID]}
                                                                hasLabel={true}
                                                                ariaLabelledBy={spec.SpecField + "label"}
                                                            />
                                                        </div>
                                                        <div className="validationError">
                                                            <span>{this.state.InputErrors[spec.SpecField]}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    }
                                    else {
                                        prioritySpecs.push(
                                            <div className="form-row" key={spec.SpecField}>
                                                <label className="label-left" htmlFor={spec.SpecField}>{spec.Label + " " + spec.Example}</label>
                                                <div className="input-right required-spec">
                                                    <TextField
                                                        type={spec.SpecDataFormat == "Number" ? "number" : null}
                                                        min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        AddCommas={spec.SpecDataFormat == "Number"}
                                                        onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                        onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                        id={spec.SpecField}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                        hasLabel={true}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    }
                                    break;
                                }
                                case "AutoComplete": {
                                    let bDisabled = false;
                                    let bFromList = false;
                                    let source = null;

                                    let oSpec = null;
                                    let oAutoComplete = null;

                                    if (spec.Dependencies != null && spec.Dependencies.length > 0) {
                                        let lstDependentSpec = this.state.DependentAutoComplete.filter(function (dependentdrop) { return dependentdrop.SpecField == spec.SpecField; });
                                        if (lstDependentSpec != null && lstDependentSpec.length > 0) {
                                            source = lstDependentSpec[0].Source;
                                            bFromList = true;
                                            if (spec.Dependencies[0].IsRequired) {
                                                bDisabled = lstDependentSpec[0].Disabled;
                                            }
                                        }
                                    }

                                    if (spec.UsesDynamicSource) {
                                        let lstDynamicSpec = this.state.oDynamicAutoComplete.filter(function (dynamicdrop) { return dynamicdrop.DefinedSpecID == spec.DefinedSpecID; });
                                        if (lstDynamicSpec != null && lstDynamicSpec.length > 0) {
                                            source = lstDynamicSpec[0].Source;
                                            bFromList = true;
                                            oSpec = spec;
                                            oAutoComplete = this.state.oDynamicAutoComplete;
                                        }
                                    }

                                    if (source == null) {
                                        let autocompletes = [];
                                        for (let InputControlListOption of spec.InputControlListOptions) {
                                            autocompletes.push(InputControlListOption.Text);
                                        }
                                        source = autocompletes;
                                    }

                                    prioritySpecs.push(
                                        <div className="form-row" key={spec.SpecField}>
                                            <label className="label-left" htmlFor={spec.SpecField}>{spec.Label + " " + spec.Example}</label>
                                            <div className="input-right required-spec">
                                                <AutoCompleteField
                                                    feRequired={spec.RecommendedForEvaluation}
                                                    FromList={bFromList}
                                                    disabled={bDisabled}
                                                    onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                    onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                    spec={oSpec}
                                                    oDynamicAutoComplete={oAutoComplete}
                                                    id={spec.SpecField}
                                                    value={this.state.FormInputs[spec.SpecField].Value}
                                                    values={source}
                                                    onFieldChanged={(value) => { this.handleFieldChanged(spec.SpecField, value); }}
                                                    error={this.state.HighlightErrors[spec.SpecField]}
                                                    errorText={this.state.InputErrors[spec.SpecField]}
                                                    hasLabel={true}
                                                />
                                            </div>
                                        </div>
                                    );
                                    break;
                                }
                                case "RadioButtonList": {
                                    let radios = [];
                                    for (let InputControlListOption of spec.InputControlListOptions) {
                                        radios.push({ text: InputControlListOption.Text, value: InputControlListOption.Value })
                                    }
                                    prioritySpecs.push(
                                        <div className="form-row" key={spec.SpecField}>
                                            <div className="input-right required-spec">
                                                <RadioField
                                                    feRequired={spec.RecommendedForEvaluation}
                                                    id={spec.SpecField}
                                                    radios={radios}
                                                    value={this.state.FormInputs[spec.SpecField].Value}
                                                    isvertical={false}
                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                    label={spec.Label + " " + spec.Example}
                                                />
                                            </div>
                                            <div className="validationError">
                                                <span>{this.state.InputErrors[spec.SpecField]}</span>
                                            </div>
                                        </div>
                                    );
                                    break;
                                }
                                case "DropDownList": {
                                    let bDisabled = false;
                                    let source = null;

                                    if (spec.Dependencies != null && spec.Dependencies.length > 0) {
                                        let lstDependentSpec = this.state.DependentAutoComplete.filter(function (dependentdrop) { return dependentdrop.SpecField == spec.SpecField; });
                                        if (lstDependentSpec != null && lstDependentSpec.length > 0) {
                                            source = lstDependentSpec[0].DropDownOptions;
                                            if (spec.Dependencies != null && spec.Dependencies[0].IsRequired) {
                                                bDisabled = lstDependentSpec[0].Disabled;
                                            }
                                        }
                                    }

                                    if (source == null) {
                                        let options = [];
                                        for (let InputControlListOption of spec.InputControlListOptions) {
                                            options.push({ text: InputControlListOption.Text, value: InputControlListOption.Value });
                                        }
                                        source = options;
                                    }

                                    prioritySpecs.push(
                                        <div className="form-row" key={spec.SpecField}>
                                            <label className="label-left" htmlFor={spec.SpecField}>{spec.Label + " " + spec.Example}</label>
                                            <div className="input-right required-spec">
                                                <SelectField
                                                    feRequired={spec.RecommendedForEvaluation}
                                                    disabled={bDisabled}
                                                    id={spec.SpecField}
                                                    value={this.state.FormInputs[spec.SpecField].Value}
                                                    values={source}
                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                    bShowFullName={true}
                                                    error={this.state.HighlightErrors[spec.SpecField]}
                                                    errorText={this.state.InputErrors[spec.SpecField]}
                                                    hasLabel={true}
                                                />
                                            </div>
                                        </div>
                                    );
                                    break;
                                }
                                case "DatePicker": {
                                    let lstBundledSpec = this.state.DependentBundledSpecs.filter(function (x) { return x.SpecID == spec.DefinedSpecID; });
                                    let bDisabled = false;
                                    let labelledBy = spec.SpecField + "DateLabel";

                                    let bundledSpecNoLabel = false;

                                    if (lstBundledSpec.length > 0) {
                                        bDisabled = this.state.FormInputs[lstBundledSpec[0].DependentSpecName].Value == "";
                                        labelledBy = lstBundleParents[0].DependentSpecName + "DateLabel";
                                        bundledSpecNoLabel = true;
                                    }

                                    if (bDisabled) {
                                        this.state.FormInputs[spec.SpecField].Value = "";
                                    }

                                    prioritySpecs.push(
                                        <div className="form-row" key={spec.SpecField}>
                                            {!bundledSpecNoLabel && <label className="label-left" htmlFor={spec.SpecField} id={spec.SpecField + "DateLabel"}>{spec.Label + " " + spec.Example}</label>}
                                            <div className="input-right required-spec">
                                                <TextField
                                                    feRequired={spec.RecommendedForEvaluation}
                                                    AddCommas={spec.SpecDataFormat == "Number"}
                                                    onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                    onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                    id={spec.SpecField}
                                                    value={this.state.FormInputs[spec.SpecField].Value}
                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                    error={this.state.HighlightErrors[spec.SpecField]}
                                                    errorText={this.state.InputErrors[spec.SpecField]}
                                                    hasLabel={true}
                                                    ariaLabelledBy={labelledBy}
                                                    bDisabled={bDisabled}
                                                />
                                            </div>
                                            {/*Hidden field needed to dispatch an event in jquery and land here in React*/}
                                            <div style={{ display: 'none' }}>
                                                <TextField
                                                    id={spec.SpecField + "DateSelected"}
                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField + "DateSelected", e); }}
                                                    hasLabel={true}
                                                    ariaLabelledBy={labelledBy}
                                                    bDisabled={bDisabled}
                                                />
                                            </div>
                                        </div>
                                    );
                                    if (typeof jQuery === 'undefined') {
                                        // jQuery is NOT available
                                    }
                                    else {
                                        $('#' + spec.SpecField).Datepicker({
                                            onSelect: function () {
                                                let element = $('#' + spec.SpecField + "DateSelected")[0];
                                                if (element != null) {
                                                    let val = $(this).val();
                                                    setElementValue(element, val);
                                                    element.dispatchEvent(new DatePickerPopup('input', { bubbles: true }));
                                                }
                                            }
                                        });
                                        if (bDisabled) {
                                            if (!($('#' + spec.SpecField).datepicker("isDisabled"))) {
                                                $('#' + spec.SpecField).datepicker("option", "disabled", true);
                                                $('#' + spec.SpecField).css('background-color', '#EBEBE4');
                                            }
                                        }
                                        else if ($('#' + spec.SpecField).datepicker("isDisabled")) {
                                            $('#' + spec.SpecField).datepicker("option", "disabled", false);
                                            $('#' + spec.SpecField).css('background-color', '#FFFFFF');
                                        }
                                    }
                                    break;
                                }
                            }
                        }
                        //we're not in a section that requires these specs
                    }
                    else {
                        let NonRequiredSpec = false;
                        //go through the remainder of these and set them to not be required
                        for (let spec of oMMMCategoryGroupSpecPage.Specs) {
                            if (!spec.Required) {
                                NonRequiredSpec = true
                                break;
                            }
                        }

                        let tempState = this.state;
                        //get all the dynamic specs for this section
                        let oDynamicSpecsInSection = oMMMCategoryGroupSpecPage.Specs.filter(function (spc) {
                            return tempState.DependentAutoComplete.some(function (dAC) {
                                return dAC.SpecID == spc.DefinedSpecID;
                            });
                        });
                        //go through each dynamic spec
                        for (let oDynamicSpec of oDynamicSpecsInSection) {
                            //find the specs these are dependent upon
                            let dependentUponSpec = oMMMCategoryGroupSpecPage.Specs.filter(function (spc) {
                                return spc.DefinedSpecID == oDynamicSpec.Dependencies[0].DefinedSpecID;
                            });
                            //if we found a spec that we're dependent upon
                            if (dependentUponSpec.length > 0) {
                                let dependentSpec = dependentUponSpec[0];
                                let formVal = this.state.FormInputs[dependentSpec.SpecField];
                                //if we have a form value to use
                                if (formVal) {
                                    let dynamicFieldToUpdate = this.state.oDynamicAutoComplete.filter(function (ac) {
                                        return ac.DefinedSpecID == oDynamicSpec.DefinedSpecID;
                                    });
                                    //update the dependencies w/ the form value
                                    if (dynamicFieldToUpdate.length > 0) {
                                        let existingDependences = dynamicFieldToUpdate[0].Dependencies;
                                        //note that on initial load this is a JSON object, so it won't have this method available at the time
                                        if (existingDependences.findIndex) {
                                            let dependencyIdx = existingDependences.findIndex(function (dep) {
                                                return dep.key == dependentSpec.DefinedSpecID;
                                            });
                                            //if we found the dependency, update the JSON object to have the new form value
                                            if (dependencyIdx != -1) {
                                                //make sure toUpperCase this value, otherwise the validation API complains
                                                let valToUse = {
                                                    key: existingDependences[dependencyIdx].key,
                                                    value: (formVal.Value.toString() || "").toUpperCase()
                                                };
                                                dynamicFieldToUpdate[0].Dependencies[dependencyIdx] = valToUse;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        if (NonRequiredSpec) {
                            //Additional Specs
                            let addtlSpecs = [];

                            //collapsible Header
                            const addtlSpecAccordionID = "addtlSpecs-groupName-" + groupNameIndex;
                            addtlGroups.push(
                                <div className="expand" key={addtlSpecAccordionID}>
                                    <button type="button" className="closed spec-group-label " id={addtlSpecAccordionID} onClick={(e) => { this.handleCloseSection(e) }}>{oMMMCategoryGroupSpecPage.GroupName}</button>
                                </div>
                            );

                            //specs for this category
                            //go through all the available specs
                            for (let spec of oMMMCategoryGroupSpecPage.Specs) {
                                if (spec.Example == null) {
                                    spec.Example = "";
                                }

                                let bIsMileageHourSpec = false;
                                if (this.state.GroupIndex != -1 && spec == this.state.oMMMCategoryGroupSpecs[this.state.GroupIndex].Specs[this.state.SpecIndex]) {
                                    bIsMileageHourSpec = true;
                                }

                                //if the spec isn't required, and is not a custom control, and isn't the MPH spec
                                if (!spec.Required && spec.SpecInputControlType != "CustomControl" && !bIsMileageHourSpec) {
                                    switch (spec.SpecInputControlType) {
                                        case "MultiLineTextBox": {
                                            addtlSpecs.push(
                                                <div className="column6 left" id={spec.SpecField + "column"} key={spec.SpecField} style={{ width: "98%" }}>
                                                    <TextField
                                                        type="textarea"
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                        onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                        id={spec.SpecField}
                                                        label={spec.Label + " " + spec.Example}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                    />
                                                </div>
                                            );
                                            break;
                                        }
                                        case "CheckBox": {
                                            if (this.state.FormInputs[spec.SpecField].Value == "") {
                                                this.state.FormInputs[spec.SpecField].Value = "0";
                                            }
                                            addtlSpecs.push(
                                                <div className="column6 left" id={spec.SpecField + "column"} key={spec.SpecField} style={{ marginTop: "15px" }}>
                                                    <TextField
                                                        inline={true}
                                                        type="checkbox"
                                                        YesNo={spec.IsYesNo}
                                                        isSpec={true}
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        id={spec.SpecField}
                                                        label={spec.Label + " " + spec.Example}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                    />
                                                </div>
                                            );
                                            break;
                                        }
                                        case "TextBox": {
                                            if (spec.DatabaseUnit != null && spec.MeasurementUnitOptions != null) {
                                                let selectID = spec.SpecField + "unit#";
                                                let selectvalues = [];

                                                for (let UnitOption of spec.MeasurementUnitOptions) {
                                                    for (let MeasurementUnit of this.state.oMMMMeasurementUnit) {
                                                        if (UnitOption == MeasurementUnit.MeasurementUnitID) {
                                                            selectvalues.push({ text: MeasurementUnit.Symbol, value: MeasurementUnit.Unit })
                                                            break;
                                                        }
                                                    }
                                                }
                                                

                                                if (this.state.FormInputs[selectID].Value == "foot") {
                                                    let inchfield = spec.SpecField + "inch#";
                                                    if (this.state.SimplifiedSite) {
                                                        addtlSpecs.push(
                                                            <div className="form-row simple-specs-row" id={spec.SpecField + "column"} key={spec.SpecField}>
                                                                <label className="label-left simple-specs-label" htmlFor={spec.SpecField} id={spec.SpecField + "label"}>{spec.Label + " " + spec.Example}</label>
                                                                <div style={{ width: "100%" }}>
                                                                    <TextField
                                                                        type="number"
                                                                        min="0"
                                                                        feRequired={spec.RecommendedForEvaluation}
                                                                        onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                                        onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                                        AddCommas={spec.SpecDataFormat == "Number"}
                                                                        id={spec.SpecField}
                                                                        isRequired={spec.Required}
                                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                                        SmallInput={true}
                                                                        className={"footSpecText"}
                                                                        mileageinch={true}
                                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                                        hasLabel={true}
                                                                    />
                                                                    <SelectField
                                                                        id={selectID}
                                                                        value={this.state.FormInputs[selectID].Value}
                                                                        SmallSelect={true}
                                                                        className={"v-small-select"}
                                                                        values={selectvalues}
                                                                        mileageinch={true}
                                                                        onFieldChanged={(e) => { this.handleFieldChanged(selectID, e); }}
                                                                        bShowFullName={true}
                                                                        error={this.state.HighlightErrors[selectID]}
                                                                        errorText={this.state.InputErrors[selectID]}
                                                                        hasLabel={true}
                                                                        ariaLabelledBy={spec.SpecField + "label"}
                                                                    />
                                                                    <TextField
                                                                        type="number"
                                                                        min="0"
                                                                        feRequired={spec.RecommendedForEvaluation}
                                                                        onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                                        onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                                        AddCommas={spec.SpecDataFormat == "Number"}
                                                                        id={inchfield}
                                                                        SmallInput={true}
                                                                        className={"inchSpecText"}
                                                                        isRequired={spec.Required}
                                                                        value={this.state.FormInputs[inchfield].Value}
                                                                        mileageinchsecond={true}
                                                                        onFieldChanged={(e) => { this.handleFieldChanged(inchfield, e); }}
                                                                        error={this.state.HighlightErrors[inchfield]}
                                                                        errorText={this.state.InputErrors[inchfield]}
                                                                        hasLabel={true}
                                                                    />
                                                                    <label htmlFor={inchfield} className="simple-specs-inches"> in.</label>
                                                                </div>
                                                                <div className="validationError">
                                                                    <span>{this.state.InputErrors[spec.SpecField]}</span>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    else {
                                                        addtlSpecs.push(
                                                            <div className="column6 left" id={spec.SpecField + "column"} key={spec.SpecField}>
                                                                <TextField
                                                                    type={spec.SpecDataFormat == "Number" ? "number" : null}
                                                                    min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                                    feRequired={spec.RecommendedForEvaluation}
                                                                    onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                                    onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                                    AddCommas={spec.SpecDataFormat == "Number"}
                                                                    id={spec.SpecField}
                                                                    isRequired={spec.Required}
                                                                    label={spec.Label + " " + spec.Example}
                                                                    value={this.state.FormInputs[spec.SpecField].Value}
                                                                    SmallInput={true}
                                                                    className={"footSpecText"}
                                                                    mileageinch={true}
                                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                                    error={this.state.HighlightErrors[spec.SpecField]}
                                                                    errorText={this.state.InputErrors[spec.SpecField]}
                                                                />
                                                                <SelectField
                                                                    id={selectID}
                                                                    value={this.state.FormInputs[selectID].Value}
                                                                    SmallSelect={true}
                                                                    className={"v-small-select"}
                                                                    values={selectvalues}
                                                                    mileageinch={true}
                                                                    onFieldChanged={(e) => { this.handleFieldChanged(selectID, e); }}
                                                                    bShowFullName={true}
                                                                    error={this.state.HighlightErrors[selectID]}
                                                                    errorText={this.state.InputErrors[selectID]}
                                                                    hasLabel={true}
                                                                    ariaLabelledBy={spec.SpecField + "label"}
                                                                />
                                                                <TextField
                                                                    type={spec.SpecDataFormat == "Number" ? "number" : null}
                                                                    min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                                    feRequired={spec.RecommendedForEvaluation}
                                                                    onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                                    onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                                    AddCommas={spec.SpecDataFormat == "Number"}
                                                                    id={inchfield}
                                                                    SmallInput={true}
                                                                    className={"inchSpecText"}
                                                                    isRequired={spec.Required}
                                                                    value={this.state.FormInputs[inchfield].Value}
                                                                    mileageinchsecond={true}
                                                                    onFieldChanged={(e) => { this.handleFieldChanged(inchfield, e); }}
                                                                    error={this.state.HighlightErrors[inchfield]}
                                                                    errorText={this.state.InputErrors[inchfield]}
                                                                    hasLabel={true}
                                                                />
                                                                <label htmlFor={inchfield}> in.</label>
                                                                <div className="validationError">
                                                                    <span>{this.state.InputErrors[spec.SpecField]}</span>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                }
                                                else if (this.state.SimplifiedSite) {
                                                    addtlSpecs.push(
                                                        <div className="form-row simple-specs-row" id={spec.SpecField + "column"} key={spec.SpecField}>
                                                            <label className="label-left simple-specs-label" htmlFor={spec.SpecField} id={spec.SpecField + "label"}>{spec.Label + " " + spec.Example}</label>
                                                            <div style={{ width: "100%" }}>
                                                                <TextField
                                                                    type={spec.SpecDataFormat == "Number" ? "number" : null}
                                                                    min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                                    feRequired={spec.RecommendedForEvaluation}
                                                                    AddCommas={spec.SpecDataFormat == "Number"}
                                                                    id={spec.SpecField}
                                                                    onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                                    onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                                    isRequired={spec.Required}
                                                                    SmallInput={true}
                                                                    value={this.state.FormInputs[spec.SpecField].Value}
                                                                    mileage={true}
                                                                    onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                                    error={this.state.HighlightErrors[spec.SpecField]}
                                                                    hasLabel={true}
                                                                />
                                                                <SelectField
                                                                    id={selectID}
                                                                    value={this.state.FormInputs[selectID].Value}
                                                                    SmallSelect={true}
                                                                    values={selectvalues}
                                                                    mileage={true}
                                                                    onFieldChanged={(e) => { this.handleFieldChanged(selectID, e); }}
                                                                    bShowFullName={true}
                                                                    error={this.state.HighlightErrors[selectID]}
                                                                    errorText={this.state.InputErrors[selectID]}
                                                                    hasLabel={true}
                                                                    ariaLabelledBy={spec.SpecField + "label"}
                                                                />
                                                                <div className="validationError">
                                                                    <span>{this.state.InputErrors[spec.SpecField]}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                else {
                                                    addtlSpecs.push(
                                                        <div className="column6 left" id={spec.SpecField + "column"} key={spec.SpecField}>
                                                            <TextField
                                                                type={spec.SpecDataFormat == "Number" ? "number" : null}
                                                                min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                                feRequired={spec.RecommendedForEvaluation}
                                                                AddCommas={spec.SpecDataFormat == "Number"}
                                                                id={spec.SpecField}
                                                                onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                                onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                                isRequired={spec.Required}
                                                                SmallInput={true}
                                                                label={spec.Label + " " + spec.Example}
                                                                value={this.state.FormInputs[spec.SpecField].Value}
                                                                mileage={true}
                                                                onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                                error={this.state.HighlightErrors[spec.SpecField]}
                                                            />
                                                            <SelectField
                                                                id={selectID}
                                                                value={this.state.FormInputs[selectID].Value}
                                                                SmallSelect={true}
                                                                values={selectvalues}
                                                                mileage={true}
                                                                onFieldChanged={(e) => { this.handleFieldChanged(selectID, e); }}
                                                                bShowFullName={true}
                                                                error={this.state.HighlightErrors[selectID]}
                                                                errorText={this.state.InputErrors[selectID]}
                                                                hasLabel={true}
                                                                ariaLabelledBy={spec.SpecField + "label"}
                                                            />
                                                            <div className="validationError">
                                                                <span>{this.state.InputErrors[spec.SpecField]}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            }
                                            else {
                                                addtlSpecs.push(
                                                    <div className="column6 left" id={spec.SpecField + "column"} key={spec.SpecField}>
                                                        <TextField
                                                            type={spec.SpecDataFormat == "Number" ? "number" : null}
                                                            min={spec.SpecDataFormat == "Number" ? "0" : null}
                                                            feRequired={spec.RecommendedForEvaluation}
                                                            AddCommas={spec.SpecDataFormat == "Number"}
                                                            onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                            onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                            id={spec.SpecField}
                                                            isRequired={spec.Required}
                                                            label={spec.Label + " " + spec.Example}
                                                            value={this.state.FormInputs[spec.SpecField].Value}
                                                            onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                            error={this.state.HighlightErrors[spec.SpecField]}
                                                            errorText={this.state.InputErrors[spec.SpecField]}
                                                        />
                                                    </div>
                                                );
                                            }
                                            break;
                                        }
                                        case "AutoComplete": {
                                            let bDisabled = false;
                                            let bFromList = false;
                                            let source = null;

                                            let oSpec = null;
                                            let oAutocomplete = null;

                                            if (spec.Dependencies != null && spec.Dependencies.length > 0) {
                                                let lstDependentSpec = this.state.DependentAutoComplete.filter(function (dependentdrop) { return dependentdrop.SpecField == spec.SpecField; });
                                                if (lstDependentSpec != null && lstDependentSpec.length > 0) {
                                                    source = lstDependentSpec[0].Source;
                                                    bFromList = true;
                                                    if (spec.Dependencies != null && spec.Dependencies[0].IsRequired) {
                                                        bDisabled = lstDependentSpec[0].Disabled

                                                        for (let DependentAutoComplete of this.state.DependentAutoComplete) {
                                                            if (DependentAutoComplete.SpecField == spec.SpecField) {
                                                                //if we have an engine spec, and this is the model field, enable it so we can fill out the value
                                                                bDisabled = DependentAutoComplete.Disabled;
                                                            }
                                                        }
                                                    }
                                                }
                                            }

                                            if (spec.UsesDynamicSource) {
                                                let lstDynamicSpec = this.state.oDynamicAutoComplete.filter(function (dynamicdrop) { return dynamicdrop.DefinedSpecID == spec.DefinedSpecID; });
                                                if (lstDynamicSpec != null && lstDynamicSpec.length > 0) {
                                                    source = lstDynamicSpec[0].Source;
                                                    bFromList = true;
                                                    oSpec = spec;
                                                    oAutocomplete = this.state.oDynamicAutoComplete;
                                                }
                                            }

                                            if (source == null) {
                                                let autocompletes = [];
                                                for (let InputControlListOption of spec.InputControlListOptions) {
                                                    autocompletes.push(InputControlListOption.Text);
                                                }
                                                source = autocompletes;
                                            }

                                            addtlSpecs.push(
                                                <div className="column6 left" id={spec.SpecField + "column"} key={spec.SpecField}>
                                                    <AutoCompleteField
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        isRequired={spec.Required}
                                                        FromList={bFromList}
                                                        onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                        onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                        disabled={bDisabled}
                                                        id={spec.SpecField}
                                                        spec={oSpec}
                                                        oDynamicAutoComplete={oAutocomplete}
                                                        label={spec.Label + " " + spec.Example}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        values={source}
                                                        onFieldChanged={(value) => { this.handleFieldChanged(spec.SpecField, value); }}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                    />
                                                </div>
                                            );
                                            break;
                                        }
                                        case "RadioButtonList": {
                                            let radios = [];
                                            for (let InputControlListOption of spec.InputControlListOptions) {
                                                radios.push({ text: InputControlListOption.Text, value: InputControlListOption.Value })
                                            }

                                            addtlSpecs.push(
                                                <div className="column6 left" id={spec.SpecField + "column"} key={spec.SpecField}>
                                                    <RadioField
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        id={spec.SpecField}
                                                        radios={radios}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        isvertical={false}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                        label={spec.Label + " " + spec.Example}
                                                        isRequired={spec.Required}
                                                    />
                                                </div>
                                            );
                                            break;
                                        }
                                        case "DropDownList": {
                                            let bDisabled = false;
                                            let bShowFullName = true;
                                            let source = null;

                                            if (spec.Dependencies != null && spec.Dependencies.length > 0) {
                                                let lstDependentSpec = this.state.DependentAutoComplete.filter(function (dependentdrop) { return dependentdrop.SpecField == spec.SpecField; });
                                                if (lstDependentSpec != null && lstDependentSpec.length > 0) {
                                                    source = lstDependentSpec[0].DropDownOptions;
                                                    if (spec.Dependencies != null && spec.Dependencies[0].IsRequired) {
                                                        bDisabled = lstDependentSpec[0].Disabled;
                                                    }
                                                    else {
                                                        bShowFullName = false;
                                                    }
                                                }
                                            }

                                            if (source == null) {
                                                let options = [];
                                                for (let InputControlListOption of spec.InputControlListOptions) {
                                                    options.push({ text: InputControlListOption.Text, value: InputControlListOption.Value });
                                                }
                                                source = options;
                                            }

                                            let sSpecClass = "spec-select";
                                            let sDivClass = "column6 left";
                                            if (this.state.SimplifiedSite) {
                                                sSpecClass = "input-right spec-select";
                                                sDivClass = "form-row";
                                            }

                                            addtlSpecs.push(
                                                <div className={sDivClass} id={spec.SpecField + "column"} key={spec.SpecField}>
                                                    <SelectField
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        isRequired={spec.Required}
                                                        disabled={bDisabled}
                                                        id={spec.SpecField}
                                                        className={sSpecClass}
                                                        placeholder={spec.Label + " " + spec.Example}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        values={source}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                        bShowFullName={bShowFullName}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                    />
                                                </div>
                                            );
                                            break;
                                        }
                                        case "CheckBoxList": {
                                            let checkboxesEven = [];
                                            let checkboxesOdd = [];
                                            let checkboxes = [];
                                            for (let c = 0; c < spec.InputControlListOptions.length; c++) {
                                                if (c % 2 == 0)
                                                    checkboxesEven.push({ text: spec.InputControlListOptions[c].Text, value: spec.InputControlListOptions[c].Value });
                                                else
                                                    checkboxesOdd.push({ text: spec.InputControlListOptions[c].Text, value: spec.InputControlListOptions[c].Value });
                                            }

                                            checkboxes.push(<span className="label" key={spec.Label + "_label"} style={{ display: "block" }}>{spec.Label + " " + spec.Example}</span>);
                                            checkboxes.push(
                                                <div className="column6 left" id={spec.SpecField + "columnLeft"} key={spec.SpecField + "Left"}>
                                                    <CheckBoxListField
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        id={spec.SpecField}
                                                        checkboxes={checkboxesEven}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        isvertical={false}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                        hasLabel={true}
                                                    />
                                                </div>
                                            );
                                            checkboxes.push(
                                                <div className="column6 left" id={spec.SpecField + "columnRight"} key={spec.SpecField + "Right"}>
                                                    <CheckBoxListField
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        id={spec.SpecField}
                                                        checkboxes={checkboxesOdd}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        isvertical={false}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                        hasLabel={true}
                                                    />
                                                </div>
                                            );

                                            let key = spec.SpecField + "List"
                                            addtlSpecs.push(
                                                <div className="spec-checkboxList" key={key} id={spec.SpecField}>
                                                    {checkboxes}
                                                </div>
                                            );
                                            break;
                                        }
                                        case "DatePicker": {
                                            let lstBundleParents = this.state.DependentBundledSpecs.filter(function (x) { return x.DependentSpecID == spec.DefinedSpecID; });
                                            let isBundleParent = lstBundleParents.length > 0;
                                            if (isBundleParent) {
                                                spec.Label = lstBundleParents[0].BundleLabel;
                                                if (addtlSpecs.length % 2 == 1) {
                                                    addtlSpecs.push(<div className="column6 left" id={spec.SpecField + "columnplaceholder"} key={"separator-" + spec.DefinedSpecID}></div>);
                                                }
                                            }
                                            let bundledSpecNoLabel = false;

                                            let lstBundledSpec = this.state.DependentBundledSpecs.filter(function (x) { return x.SpecID == spec.DefinedSpecID; });
                                            let bDisabled = false;

                                            let labelledBy = spec.SpecField + "DateLabel";
                                            if (lstBundledSpec.length > 0) {
                                                bundledSpecNoLabel = true;
                                                bDisabled = this.state.FormInputs[lstBundledSpec[0].DependentSpecName].Value == "";
                                                labelledBy = lstBundledSpec[0].DependentSpecName + "DateLabel";
                                            }

                                            if (bDisabled) {
                                                this.state.FormInputs[spec.SpecField].Value = "";
                                            }

                                            addtlSpecs.push(
                                                <div className="column6 left" id={spec.SpecField + "column"} key={spec.SpecField}>
                                                    {bundledSpecNoLabel ? <div style={{ height: "20px" }}></div> : <label id={spec.SpecField + "DateLabel"} htmlFor={spec.SpecField}>{spec.Label + " " + spec.Example} {"\n"}</label>}
                                                    <TextField
                                                        feRequired={spec.RecommendedForEvaluation}
                                                        AddCommas={spec.SpecDataFormat == "Number"}
                                                        onBlur={(e) => { this.handleOnBlur(spec.SpecField, e); }}
                                                        onFocus={(e) => { this.handleOnFocus(spec.SpecField, e); }}
                                                        id={spec.SpecField}
                                                        isRequired={spec.Required}
                                                        value={this.state.FormInputs[spec.SpecField].Value}
                                                        onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField, e); }}
                                                        error={this.state.HighlightErrors[spec.SpecField]}
                                                        errorText={this.state.InputErrors[spec.SpecField]}
                                                        hasLabel={true}
                                                        ariaLabelledBy={labelledBy}
                                                        bDisabled={bDisabled}
                                                    />
                                                    {/*Hidden field needed to dispatch an event in jquery and land here in React*/}
                                                    <div style={{ display: 'none' }}>
                                                        <TextField
                                                            id={spec.SpecField + "DateSelected"}
                                                            onFieldChanged={(e) => { this.handleFieldChanged(spec.SpecField + "DateSelected", e); }}
                                                            hasLabel={true}
                                                            ariaLabelledBy={labelledBy}
                                                            bDisabled={bDisabled}
                                                        />
                                                    </div>
                                                </div>
                                            );

                                            if (typeof jQuery === 'undefined') {
                                                // jQuery is NOT available
                                            }
                                            else {
                                                $('#' + spec.SpecField).datepicker({
                                                    onSelect: function () {
                                                        let element = $('#' + spec.SpecField + "DateSelected")[0];
                                                        if (element != null) {
                                                            let val = $(this).val();
                                                            setElementValue(element, val);
                                                            element.dispatchEvent(new DatePickerPopup('input', { bubbles: true }));
                                                        }
                                                    }
                                                });
                                                if (bDisabled) {
                                                    if (!($('#' + spec.SpecField).datepicker("isDisabled"))) {
                                                        $('#' + spec.SpecField).datepicker("option", "disabled", true);
                                                        $('#' + spec.SpecField).css('background-color', '#EBEBE4');
                                                    }
                                                }
                                                else if ($('#' + spec.SpecField).datepicker("isDisabled")) {
                                                    $('#' + spec.SpecField).datepicker("option", "disabled", false);
                                                    $('#' + spec.SpecField).css('background-color', '#FFFFFF');

                                                }
                                            }
                                            break;
                                        }
                                    }
                                }
                            }

                            //Check in a list of valid keys, if particular element contains keys, push it
                            if (this.state.SimplifiedSite) {
                                let keySpecs = ["HorsePower", "NumSleeps", "NumSlideOuts", "Length"];
                                for (let spec of addtlSpecs) {
                                    if (keySpecs.includes(spec.key)) {
                                        simpleSpecGroups.push(
                                            <div key={spec.key}>
                                                <div className="validationError">
                                                    <span>{this.state.FormErrors}</span>
                                                </div>
                                                {spec}
                                            </div>
                                        );
                                    }
                                }
                            }
                            //add the specs to an accordion group if not simplified
                            else {
                                const addtlSpecsID = "addtlSpecs-content-" + groupNameIndex;
                                addtlGroups.push(
                                    <div key={addtlSpecsID}>
                                        <div className="accordion" id={addtlSpecsID} >
                                            <div className="validationError">
                                                <span>{this.state.FormErrors}</span>
                                            </div>
                                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                                {addtlSpecs}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }

                            groupNameIndex++;
                        }
                    }

                    //add the additional accordion after required specs
                    if (((this.state.Translations["PrioritySpecs"].includes(oMMMCategoryGroupSpecPage.GroupName)) || groupIndex == 0) && !this.state.SimplifiedSite) {
                        prioritySpecs.push(
                            <div className="additional-details" key="AdditionalDetails" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { this.AdditionaDetailsClick(e); }}} onClick={(e) => { this.AdditionaDetailsClick(e) }} tabIndex="0">
                                <div className="toggle-details">
                                    <strong style={{ display: 'block' }}>{this.getTranslation("AdditionalDetails")} <i className="fa fa-plus" aria-hidden="true"></i></strong>
                                    {this.getTranslation("MoreDetails")}
                                </div>
                                <div className="toggle-details-2" style={{ display: 'none' }}>
                                    <strong>Close Additional Details <i className="fa fa-minus" aria-hidden="true"></i></strong>
                                </div>
                            </div>
                        );
                    }
                }
            }

            if (this.state.SimplifiedSite) {
                // Push simplified content for RVUniverse 
                simpleSpecSection.push(
                    <div className="simple-content" key="addtlGroups">
                        {simpleSpecGroups}
                    </div>
                )
            }
            else {
                //if no category is chosen and no RVUniverse, don't show them ` specs table to view additional info
                if (this.state.Category == "0") {
                    prioritySpecs.push(
                        <div className="additional-details" key="AdditionalDetails" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { this.AdditionaDetailsClick(e); } }} onClick={(e) => { AdditionalDetailsToggle() }} tabIndex="0" style={{ display: 'none' }}>
                            <div className="toggle-details">
                                <strong style={{ display: 'block' }}>{this.getTranslation("AdditionalDetails")} <i className="fa fa-plus" aria-hidden="true"></i></strong>
                                {this.getTranslation("MoreDetails")}
                            </div>
                            <div className="toggle-details-2" style={{ display: 'none' }}>
                                <strong>Close Additional Details <i className="fa fa-minus" aria-hidden="true"></i></strong>
                            </div>
                        </div>
                    );

                    addtlSpecsSection.push(
                        <div className="additional-content" key="addtlGroups" style={{ display: 'none' }}>
                            {addtlGroups}
                        </div>
                    );
                }
                else if (this.state.Category != "0") {
                    //add additional specs to the additional specs section
                    addtlSpecsSection.push(
                        <div className="additional-content" key="addtlGroups">
                            {addtlGroups}
                        </div>
                    );
                }
            }
        }

        if (this.state.SimplifiedSite) {
            return (
                <div className="SpecForm">
                    <div>
                        {prioritySpecs}
                        {addtlSpecsSection}
                        {simpleSpecSection}
                    </div>

                    <ModalSwitchSpecUnitsForm
                        model={this.state.modalObject}
                        handleFormUpdate={(e) => { this.props.handleFormUpdate(e); }}
                        handleMasterViewUpdate={(e) => { this.props.handleMasterViewUpdate(e); }}
                        ValidateAndSaveSpecs={this.props.ValidateAndSaveSpecs}
                        SaveSpecsToXML={this.props.SaveSpecsToXML}
                        parentModel={this.state}
                    />
                </div>
            );
        }
        else {
            return (
                <div className="SpecForm">
                    <div>
                        {prioritySpecs}
                        {addtlSpecsSection}
                    </div>

                    <ModalSwitchSpecUnitsForm
                        model={this.state.modalObject}
                        handleFormUpdate={(e) => { this.props.handleFormUpdate(e); }}
                        handleMasterViewUpdate={(e) => { this.props.handleMasterViewUpdate(e); }}
                        ValidateAndSaveSpecs={this.props.ValidateAndSaveSpecs}
                        SaveSpecsToXML={this.props.SaveSpecsToXML}
                        parentModel={this.state}
                    />
                </div>
            );
        }
    }
}

export default SpecsForm;
global.SpecsForm = SpecsForm;